/**
 * Pure helpers for the country switch page: what a country offers its viewer to do.
 */
import type { Country } from '../../services/adminJurisdictions.service';

export const REASON_MIN = 5;
/** Canada is the third market: named, and not switched on until it is built (M-31). */
export const NEVER_ON = 'CA';

export type CountryAction = 'off' | 'on' | 'none';

/** The one thing the page offers for a country: switch it off (it is on), switch it on, or
 * nothing (Canada). */
export function countryAction(c: Country): CountryAction {
  if (c.enabled) return 'off';
  return c.code === NEVER_ON ? 'none' : 'on';
}

export function reasonProblem(reason: string): string | null {
  return reason.trim().length < REASON_MIN ? 'Write the reason, at least 5 characters.' : null;
}

/** The state of a country in a word. Static texts: the Spanish is keyed by the exact sentence. */
export function stateLabel(c: Country): string {
  return c.enabled ? 'Enabled' : 'Not enabled';
}
